import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type OutlinedFieldDirection = "rtl" | "ltr";

export const useOutlinedFieldTheme = () => {
  const { t } = useTranslation();
  const direction = t("direction") as OutlinedFieldDirection;
  const isRTL = direction === "rtl";
  const theme = useMemo(() => createTheme({ direction }), [direction]);

  return { direction, isRTL, theme };
};
